import { LocalStorage } from "@made-people/local-storage";

const MM_VISITOR_EMAIL_KEY = "mm-visitor-email";
const MM_VISITOR_EMAIL_TTL_SECONDS = 60 * 60 * 24 * 30;

export const getStoredMmVisitorEmail = (): string | undefined =>
  LocalStorage.getWithExpiry(MM_VISITOR_EMAIL_KEY);

export const setStoredMmVisitorEmail = (email: string): void => {
  LocalStorage.setWithExpiry(
    MM_VISITOR_EMAIL_KEY,
    email,
    MM_VISITOR_EMAIL_TTL_SECONDS,
  );
};

export const clearStoredMmVisitorEmail = (): void => {
  LocalStorage.remove(MM_VISITOR_EMAIL_KEY);
};
